class ChessFlatsInfo {
    constructor(el) {
        if (!el) {
            console.error('ChessFlatsInfo class constructor requires "el" argument!');
            return;
        }

        let optsTooltip = {
            animateFill: false,
            flipOnUpdate: true,
            flipBehavior: ['top', 'bottom'],
            theme: 'ChessHouseFlatInfo',
            // trigger: 'click',
            placement: 'top',
            zIndex: 10001,
            animation: 'shift-toward',
            content(reference) {
                let flatInfo     = reference.querySelector('.ChessHouseFlatInfo').innerHTML;
                let isCommercial = reference.querySelector('.ChessHouseFlatInfo').classList.contains('_commercial');
                let tpl          = `<div class="ChessHouseFlatInfo _visible ${isCommercial ? '_commercial': ''}">${flatInfo}</div>`;
                return tpl;
            },
        };

        this.el = $(el);
        this.optsTooltip = optsTooltip;

        if ( $window.width() > 1280 ) {
            this.openTooltip();
        } else {
            this.openPopup();
        }

        $(window).on(
            "resize",
            _.debounce(() => {
                if ( $window.width() > 1280 ) {
                    this.openTooltip();
                } else {
                    this.openPopup();
                }
            }, 80)
        );
    }

    openTooltip() {
        this.el.off('click');
        this.el.find('[data-flat-link]').off('click');
        this.el.on('mouseenter', (e) => {
            let currentEl = e.currentTarget;
            this.tooltips = tippy(currentEl, this.optsTooltip);
        });
        this.el.on('mouseleave', (e) => {
            this.tooltips = null;
        });
    }

    openPopup() {
        this.el.off('mouseleave mouseenter click');
        this.el.on('click', function(e) {
            e.preventDefault();
            console.log('this', $(this))
            let currentEl = e.currentTarget;
            let flatInfo  = $(currentEl).find('.ChessHouseFlatInfo').html();
            let isCommercial = $(currentEl).find('.ChessHouseFlatInfo').hasClass('_commercial');
            let tpl       = `<div class="ChessHouseFlatInfo _visible ${isCommercial ? '_commercial': ''}">${flatInfo}</div>`;
            $.fancybox.open( tpl, {
                touch: false,
                btnTpl : {
                    smallBtn : '<div data-fancybox-close class="CloseIcon _outside"></div>'
                }
            });
        });
        this.el.find('[data-flat-link]').on('click', function (e) {
            e.preventDefault();
        });
    }
}